import axios from 'axios';

axios.interceptors.response.use((response) => {

    return response;
  }, error => {
    
    if(error.response && error.response.status ==401){
        var url = error.request.responseURL ? error.request.responseURL : error.response.config.url;
        if (!url.endsWith("/Code") && !url.endsWith("/CodePDF")) {        
         //Authenticated request redirected but "Code" based calls pass thru
            window.location= `${process.env.REACT_APP_LOGIN_URL}?ReturnUrl=${window.location.href}`;    
        }
    }        
    return Promise.reject(error);
  });

axios.interceptors.request.use(
  request=> {
        request.headers["X-Application-Name"] = "Correspondence Manager";
        return request;
  },
  error=> {
    return Promise.reject(error);
  }
);
  

export const getLoggedInUserInfo = async () => {
    var temp = await axios.get(`${ process.env.REACT_APP_API_URL }/api/Login/LoggedInUserInfo`, {withCredentials: true} );
    return temp.data;    
}


export const login = async (userName) => {
    var temp = await axios.post(`${process.env.REACT_APP_API_URL}/api/Login`, {userName}, {withCredentials: true} );
    return temp.data;    
}

export const getRecipientFormsList = async (recipientId,adminRequestedType) => {
    var url = `${ process.env.REACT_APP_API_URL }/api/FormInstance/RecipientFormInstanceList/${recipientId}`;
    if(adminRequestedType)
        url+=`?adminRequestedType=${adminRequestedType}`;
    var temp = await axios.get( url , {withCredentials: true} );
    return temp.data;
};

export const deleteInstance = async (id) => {
    var temp = await axios.delete(`${ process.env.REACT_APP_API_URL }/api/FormInstance/${id}`, {withCredentials: true} );
    return temp.data;
};

export const getInstance = async id => {
    var temp = await axios.get(`${ process.env.REACT_APP_API_URL }/api/FormInstance/${id}`, {withCredentials: true});
    return temp.data;
};

export const addInstance = async (selectedRecipientId, formId)=> {

        console.log(formId);
        await axios.post(`${process.env.REACT_APP_API_URL}/api/FormInstance`, {formId, selectedRecipientId } , {withCredentials: true});
};

export const addAnonymousInstance = async (selectedRecipientId, targetId, formId, keyFieldValues, existingInstanceId) => {
    try {
        // keyFieldValues may be an object { TagName: value }; serialize for QInstance.KeyField
        const keyField = keyFieldValues && typeof keyFieldValues === "object"
            ? Object.keys(keyFieldValues).sort().map(k => `${k}=${keyFieldValues[k]}`).join("|")
            : (keyFieldValues || "");
        var temp = await axios.post(`${process.env.REACT_APP_API_URL}/api/FormInstance/CreateAnonymousInstance`, {
            formId,
            targetId,
            selectedRecipientId,
            keyFieldValuesWithTag: keyField,
            // LW260806 Co#5394: reopen selected incomplete/complete instance instead of creating empty
            existingInstanceId: existingInstanceId || 0
        }, { withCredentials: true });
        return temp.data;
    } catch (error) {
        throw (error);
    }
}


// LW251124 - CO#4000 Save Feature,  add time limit verbiage
export const EraseExpiredFormAnswer = async (selectedRecipientId, targetId, formId) => {
    try {
        var data = await axios.post(`${process.env.REACT_APP_API_URL}/api/FormInstance/EraseExpiredFormAnswer`, { formId, targetId, selectedRecipientId }, { withCredentials: true });
        return data;
    } catch (error) {
        throw (error);
    }
}

export const getUsers = async (searchText,lookupType) => {
    var temp = await axios.get(`${ process.env.REACT_APP_API_URL }/api/Login/CarrierOrEmployerUsers/${lookupType}/?searchText=${searchText}&maxNumber=25`);
    return temp.data;
};

// Un-identified submission
// LW250701 CO#3613: FEIN, Policy Number, and Bureau File Number, coded for PA only for VFEV Form
// LW251124 - CO#4001 Form prepopulated data does not match the selected policy on the intermediary page
export const getUnidentifiedUser = async (searchText, lookupType, formId, stateCode) => {
    //console.log("lookupType=" + lookupType + ",stateCode=" + stateCode+ ",formId=" + formId);
    var temp = await axios.get(`${process.env.REACT_APP_API_URL}/api/Login/UnidentifiedUserInfo/${lookupType}/?searchText=${searchText}&formId=${formId}&maxNumber=25&stateCode=${stateCode}`);
    return temp.data;
};


export const getEmployerOrCarrierRecipients = async(searchText,lookupType) => {
    var temp = await axios.get(`${process.env.REACT_APP_API_URL}/api/Login/EmployerOrCarrierRecipients/${lookupType}/?searchText=${searchText}&maxNumber=25`, { withCredentials: true });
    return temp.data;
};

export const getForm = async id => {
    var temp = await axios.get(`${ process.env.REACT_APP_API_URL }/api/Form/${id}`, {withCredentials: true});
    return temp.data;
};

//get Questionnaire info, i.e. RecipientWFTargetTypeID
export const getQuestionnaireInfo = async id => {
    var temp = await axios.get(`${process.env.REACT_APP_API_URL}/api/Form/QuestionnaireInfo/${id}`, { withCredentials: true });
    return temp.data;
}; 

//get QQuestionColumns info, i.e. (TagName, QInputTypeCode, QDataTypeCode, KeyFieldFlag) values (ChangeEffectiveDate,text,DATE,1)
export const getQQuestionColumnsInfo = async id => {
    var temp = await axios.get(`${process.env.REACT_APP_API_URL}/api/Form/QQuestionColumnsInfo/${id}`, { withCredentials: true });
    return temp.data;
}; 

// LW250604 - CO#2737: Un-identified Submission
export const decodeFormId = async id => {
    var temp = await axios.get(`${process.env.REACT_APP_API_URL}/api/Form/Decode/${id}`, { withCredentials: true });
    return temp.data;
};

export const getAllForms = async recipientId => {
    var temp = await axios.get(`${process.env.REACT_APP_API_URL}/api/Form/User/${recipientId}`, {withCredentials: true}); //should remove and use cookie
    return temp.data;
};

export const refreshCookie = async() => {
    var temp = await axios.post(`${process.env.REACT_APP_API_URL}/api/TicketRefresh/`, {withCredentials: true}); //should remove and use cookie
    return temp.data;
};


export const postForm = async json => {
    try {
        var data = await axios.post(`${process.env.REACT_APP_API_URL}/api/Form`, json, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        console.log(data);
    } catch (error) {
        console.log(error);
        throw(error);
    }
}

export const postFormInstance = async json => {
    try {
        var data = await axios.post(`${process.env.REACT_APP_API_URL}/api/FormInstance`, json, {withCredentials: true});
        console.log(data);
    } catch (error) {
        console.log(error);
        throw(error);
    }
}

export const putFormData = async json => {
    try {
        var data = await axios.put(`${process.env.REACT_APP_API_URL}/api/FormInstance`, json, {withCredentials: true});
        return data;
    } catch (error) {
        throw(error);    
    }
}


export const getInternalDirect = async key => {
    try {
        var data = await axios.post(`${process.env.REACT_APP_API_URL}/api/FormInstance/InternalDirect`,{"key":key}, {withCredentials: true});
        return data;
    } catch (error) {
        throw(error);    
    }
}

export const getExternalDirect = async key => {
    try {
        var data = await axios.post(`${process.env.REACT_APP_API_URL}/api/FormInstance/ExternalDirect`,{"key":key}, {withCredentials: true});
        return data;
    } catch (error) {
        throw(error);    
    }
}

export const getDataByCode = async (key1,key2) => {
    try {
        var data = await axios.post(`${process.env.REACT_APP_API_URL}/api/FormInstance/Code`,{"Key1":key1,"Key2":key2 }, {withCredentials: true});
        return data;
    } catch (error) {
        throw(error);    
    }
}

export const getAnonymousDataByCode = async (key1, key2) => {
    try {
        var data = await axios.post(`${process.env.REACT_APP_API_URL}/api/FormInstance/AnonymousCode`, { "Key1": key1, "Key2": key2 }, { withCredentials: true });
        return data;
    } catch (error) {
        throw (error);
    }
}

export const GetAnonymousFormStatus = async (key1, key2, keyFieldValues) => {
    try {
        // Keep TagName=value so server can parse; KeyField comparison uses values only
        const keyField = keyFieldValues && typeof keyFieldValues === "object"
            ? Object.keys(keyFieldValues).sort().map(k => `${k}=${keyFieldValues[k]}`).join("|")
            : (keyFieldValues || "");
        var data = await axios.post(`${process.env.REACT_APP_API_URL}/api/FormInstance/GetAnonymousFormStatus`, { "Key1": key1, "Key2": key2, "keyFieldValuesWithTag": keyField }, { withCredentials: true });
        return data;
    } catch (error) {
        throw (error);
    }
}

export const getFormListByCode = async (key1,key2) => {
    try {
        var data = await axios.post(`${process.env.REACT_APP_API_URL}/api/FormInstance/RecipientFormInstanceListForCode`,{"Key1":key1,"Key2":key2 }, {withCredentials: true});
        return data;
    } catch (error) {
        throw(error);    
    }
}

export const putFormDataForCode = async json => {
    try {
        var data = await axios.put(`${process.env.REACT_APP_API_URL}/api/FormInstance/Code`, json, {withCredentials: true});
        return data;
    } catch (error) {
        throw(error);    
    }
}

export const putAnonymousFormDataForCode = async json => {
    try {
        var data = await axios.put(`${process.env.REACT_APP_API_URL}/api/FormInstance/AnonymousCode`, json, { withCredentials: true });
        return data;
    } catch (error) {
        throw (error);
    }
}

export const getAnalyticsData = async (key) => {
    try {
        var data = await axios.get(`${process.env.REACT_APP_API_URL}/api/Analytics?k=${key}`);
        return data;
    } catch (error) {
        throw(error);    
    }
}

export const getAttachedFileContent = async (qInstanceId, fileName) => {
    try {
        var data = await axios.post(`${process.env.REACT_APP_API_URL}/api/FormInstance/AttachedFileContent`, { "qInstanceId": qInstanceId, "fileName": fileName }, { withCredentials: true });
        return data;
    } catch (error) {
        throw (error);
    }
}

export const reCaptchaResponse = async (token) => {
    let success = false;
    try {
        //LW260209 CO#4273 Ownership Form not Opening when entering Policy # or Bureau File #
        var resp = await axios.post(`${process.env.REACT_APP_API_URL}/api/Login/Captcha`
            , { userResponse: token });
        if (resp.data.success) {
            success = true;
        }
        return {
            valid: success
        };
    } catch (error) {
        console.error("Error calling function: ", error);
        throw (error);
    }
}

// LW251013 CO#3820 New Member-  NAIC Carrier Code ( Intermediary) 
export const isActiveNAICMember = async (naicCode, stateCode) => {
    try {
        //console.log("naicCode, stateCode in dataService call= " + naicCode + "," + stateCode);
        var temp = await axios.post(`${process.env.REACT_APP_API_URL}/api/Login/IsActiveNAICMember`, { "naicCode": naicCode, "stateCode": stateCode }, { withCredentials: true });
        if (temp && temp.data[0])
            //console.log("temp.data[0].memberStatus= " + temp.data[0].memberStatus);
        return temp.data;
    } catch (error) {
        console.error("Error calling isActiveNAICMember: ", error);
        throw (error);
    }
}
